import React from 'react'
import { connect } from 'react-redux'
import MarkdownWrapper from '../../utils/markdown-wrapper'

const KeyIssueSummary = ({ selectedFilter, filterObjects }) => {
    const renderSummary = () => {
        const filter = filterObjects.find(f => f.name === selectedFilter)

        if (!filter) {
            return null
        }

        return (
            <div className={`key-issue-summary ${filter.color || ''}-bg`}>
                <div className="category">
                    {filter.name}
                </div>
                <div className="content">
                    <MarkdownWrapper content={filter.description || ''} />
                </div>
            </div>
        )
    }

    return renderSummary()
}

export default connect()(KeyIssueSummary)
